import { render, staticRenderFns } from "./addPhone.vue?vue&type=template&id=b7503530&scoped=true&"
import script from "./addPhone.vue?vue&type=script&lang=js&"
export * from "./addPhone.vue?vue&type=script&lang=js&"
import style0 from "./addPhone.vue?vue&type=style&index=0&id=b7503530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7503530",
  null
  
)

export default component.exports